import { Component, OnInit } from '@angular/core';
import { ConstantsService } from 'src/app/constants.service';

@Component({
  selector: 'app-cookiespolicy',
  templateUrl: './cookiespolicy.component.html',
  styleUrls: ['./cookiespolicy.component.scss']
})
export class CookiespolicyComponent implements OnInit {

  constructor(private _constantsService: ConstantsService) { 
    this._constantsService.setValue(true);
  }

  ngOnInit() {
  }

}
